@if (show) {
    <div class="back-drop" style="display: flex; justify-content: center; align-items: center">
        <mat-card appearance="outlined" class="login-panel">
            <img mat-card-image src="assets/sign-in-{{compound}}.png"/>
            <mat-card-content>
                <mat-tab-group>
                    <mat-tab label="Apply for Residence Tutor">
                        <div class="sso-area" style="display: flex; justify-content: center; align-items: center">
                            <a [href]="getSsoUrl()"
                               color="primary" mat-raised-button>CityUHK Web Sign On
                            </a>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </mat-card-content>
            <mat-card-footer>
                Version: {{ version }}
            </mat-card-footer>
        </mat-card>
    </div>
}


